import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-mississippi-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./mississippi-state-form.component.html",
  styleUrl: "./mississippi-state-form.component.scss",
})
export class MississippiStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
